"use strict";
import { Token } from "@uniswap/sdk-core";
import { RING_MINT_STABLE_TOKENS, RING_STABLE_MINTER_ADDRESSES, RING_USDR_TOKENS } from "constants/ring";
import { MINT_INPUT_STABLES } from "pages/Mint/IRingStableMinter";
import { UniverseChainId } from "uniswap/src/features/chains/types";
import { isAddress } from "utilities/src/addresses";
const TOKEN_NAMES = {
  USDR: "Ring USD",
  USDT: "Tether USD",
  USDC: "USD Coin",
  DAI: "Dai Stablecoin"
};
const SUPPORTED_MINT_CHAIN_IDS = /* @__PURE__ */ new Set([UniverseChainId.Mainnet, UniverseChainId.Sepolia]);
function normalizeChainId(value) {
  const parsed = Number(value ?? UniverseChainId.Sepolia);
  return SUPPORTED_MINT_CHAIN_IDS.has(parsed) ? parsed : void 0;
}
function envAddress(env, key) {
  return isAddress(env[key]) || void 0;
}
function envNumber(env, key, fallback) {
  const parsed = Number(env[key]);
  return Number.isInteger(parsed) && parsed >= 0 ? parsed : fallback;
}
function chainSuffix(chainId) {
  return chainId === UniverseChainId.Sepolia ? "SEPOLIA" : "MAINNET";
}
function chainName(chainId) {
  if (chainId === UniverseChainId.Mainnet) {
    return "Ethereum";
  }
  if (chainId === UniverseChainId.Sepolia) {
    return "Sepolia";
  }
  return "Unsupported network";
}
function configuredToken(env, chainId, symbol, fallback) {
  const suffix = chainSuffix(chainId);
  const address = envAddress(env, `REACT_APP_${symbol}_${suffix}`) ?? envAddress(env, `REACT_APP_${symbol}`) ?? fallback?.address;
  if (!address) {
    return void 0;
  }
  const decimals = envNumber(env, `REACT_APP_${symbol}_DECIMALS_${suffix}`, fallback?.decimals ?? 18);
  const name = fallback?.name ?? TOKEN_NAMES[symbol];
  return new Token(chainId, address, decimals, symbol, name);
}
export function buildMintConfig(env = process.env) {
  const chainId = normalizeChainId(env.REACT_APP_USDR_MINT_CHAIN_ID);
  if (!chainId) {
    return {
      chainName: "Unsupported network",
      stables: [],
      error: "Mint not configured on this network"
    };
  }
  const suffix = chainSuffix(chainId);
  const minterAddress = envAddress(env, `REACT_APP_RING_STABLE_MINTER_${suffix}`) ?? envAddress(env, "REACT_APP_RING_STABLE_MINTER") ?? RING_STABLE_MINTER_ADDRESSES[chainId];
  const configuredStableTokens = RING_MINT_STABLE_TOKENS[chainId] ?? [];
  const stableTokens = MINT_INPUT_STABLES.map(
    (symbol) => configuredToken(
      env,
      chainId,
      symbol,
      configuredStableTokens.find((token) => token.symbol === symbol)
    )
  ).filter((token) => Boolean(token));
  const usdr = configuredToken(env, chainId, "USDR", RING_USDR_TOKENS[chainId]);
  const error = minterAddress && usdr && stableTokens.length === 3 ? void 0 : "Mint not configured on this network";
  return {
    chainId,
    chainName: chainName(chainId),
    minterAddress,
    usdr,
    stables: stableTokens,
    error
  };
}
export const MINT_CONFIG = buildMintConfig();
export const MINT_CHAIN_ID = MINT_CONFIG.chainId;
export const MINT_CHAIN_NAME = MINT_CONFIG.chainName;
export const RING_STABLE_MINTER_ADDRESS = MINT_CONFIG.minterAddress;
export const MINT_USDR = MINT_CONFIG.usdr;
export const MINT_STABLE_CURRENCIES = MINT_CONFIG.stables;
